type RemoveNonIndexableValues<TElement> = {
  [K in keyof TElement as TElement[K] extends PropertyKey
    ? K
    : never]: TElement[K];
};

type Options<TElement, P extends PropertyKey> =
  | {
      key: keyof RemoveNonIndexableValues<TElement>;
      getKey?: never;
    }
  | {
      key?: never;
      getKey: (item: TElement) => P;
    };

export function groupArray<TElement, P extends PropertyKey = PropertyKey>(
  arr: TElement[],
  options: Options<TElement, P>,
): Record<P, TElement[]> {
  const groups: Record<PropertyKey, TElement[]> = {};

  for (const item of arr) {
    const group = options.getKey
      ? options.getKey(item)
      : (item[options.key] as PropertyKey);
    groups[group] ??= [];

    groups[group].push(item);
  }

  return groups;
}
